
let EventPage = () => import('../pages/Event')

export default [
    {
        path: '/event/:slug',
        component: EventPage,
        name: 'EventPage',
        meta: { requiresAuth: false },
    },
]
